module.exports = {
    fb_code: '2758352850844950',
    google_id : '1095274504146-qi5o87qaqq5ll99p2p1ng0j3ppvv72rm.apps.googleusercontent.com',
    API_ROOT : 'https://dev.sharmeensahibole.com/api/v1',
    API_NO_ROOT : 'https://dev.sharmeensahibole.com',
    GA_id : ''
}


// WEBPACK FOOTER //
// ./src/env/local.js